import { PROMOTION_PRICE_BID_STATUS } from "features/Products/constants";
import useFiltersTag from "./useFiltersTag";

export const FiltersTag = ({
  params,
  handleRemoveFilterTag,
  rangeDateTimeFilter,
  expiryDateTimeFilter,
  statusTabs,
  optionOwnerType,
  optionStatus,
  staffs,
  sellersOptions,
  sellerFilterOptions,
}) => {
  const {
    renderTagsStatusRequestImport,
    renderTagsWarehouseIDs,
    renderTagsTypes,
    renderTagsSupplierIDs,
    renderTagsupdatedByIDs,
    renderTagsSellerID,
    renderTagTimeRangeFilter,
    renderTagExpiryTimeRangeFilter,
  } = useFiltersTag({
    params,
    handleRemoveFilterTag,
    rangeDateTimeFilter,
    expiryDateTimeFilter,
    optionOwnerType,
    optionStatus,
    staffs,
    sellersOptions,
    sellerFilterOptions,
  });
  return (
    <div style={{ marginBottom: "12px" }}>
      {params?.filters?.statuses?.length > 0 && statusTabs === PROMOTION_PRICE_BID_STATUS.ALL
        ? renderTagsStatusRequestImport
        : null}
      {params?.filters?.warehouseIDs?.length > 0 ? renderTagsWarehouseIDs : ""}
      {params?.filters?.types?.length > 0 && params?.filters?.types?.length < 2 ? renderTagsTypes : ""}
      {params?.filters?.supplierIDs?.length > 0 ? renderTagsSupplierIDs : ""}
      {params?.filters?.updatedByIDs?.length > 0 ? renderTagsupdatedByIDs : ""}
      {params?.filters?.sellerID ? renderTagsSellerID : ""}
      {rangeDateTimeFilter?.from !== undefined ? renderTagTimeRangeFilter : ""}
      {expiryDateTimeFilter?.from !== undefined ? renderTagExpiryTimeRangeFilter : ""}
    </div>
  );
};

export default FiltersTag;
